import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  Icon, Modal, Form, Transition, Header,
} from 'semantic-ui-react';
import { UPDATE_JOB } from '../../../../../queries/job';

const OfferRateButton = ({ job }) => {
  const [open, setOpen] = useState(false);
  const [offerRate, setOfferRate] = useState(job.offerRate);
  const [isSaved, setIsSaved] = useState(false);

  const [updateJob, { loading }] = useMutation(
    UPDATE_JOB,
    {
      onCompleted: () => {
        setIsSaved(true);
        setTimeout(() => setIsSaved(false), 3000);
      },
    },
  );

  const onSubmit = () => {
    updateJob({
      variables: {
        userId: job.expert.id,
        projectId: job.project.id,
        job: {
          hourlyRate: offerRate,
        },
      },
    });
  };

  return (
    <div style={{ display: 'inline', margin: '0.5rem' }}>
      <Header as="h5" style={{ display: 'inline' }}>{`$${job.offerRate}/hr`}</Header>
      <Modal
        closeIcon
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        trigger={(
          ['Invited', 'Past', 'Upcoming', 'Accepted'].includes(job.status) && (
            <Icon
              link
              name="pencil"
              color="black"
              style={{ display: 'inline' }}
            />
          )
        )}
      >
        <Modal.Header>{`Edit ${job.expert.fullName}'s Rate`}</Modal.Header>
        <Modal.Content>
          <Form onSubmit={onSubmit}>
            {isSaved && (
              <Transition visible={isSaved} animation="scale" duration={500}>
                <Header color="green">Successfully saved!</Header>
              </Transition>
            )}
            <Form.Input
              icon="dollar"
              iconPosition="left"
              type="number"
              label="Offer Rate"
              min={1}
              value={offerRate}
              onChange={(e, { value }) => setOfferRate(parseInt(value, 10))}
            />
            <Form.Button
              content="Save"
              loading={loading}
              disabled={loading}
            />
          </Form>
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default OfferRateButton;
